
const SellCTASection = () => {
  return (
    <section className="py-20 bg-navy">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="font-playfair text-4xl font-bold text-white mb-6">
          Take the First Step
        </h2>
        <p className="text-xl text-gray-200 mb-8 leading-relaxed">
          The hardest part is often just starting the conversation. Let's talk about your business, your goals, and your options with no pressure and complete confidentiality.
        </p>
        <button 
          onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
          className="btn-primary text-lg px-8 py-4"
        >
          Schedule a Confidential Call
        </button>
        <p className="text-sm text-gray-300 mt-6">
          <i className="ri-shield-check-line mr-2"></i>
          All conversations are confidential and handled directly by Brian
        </p>
      </div>
    </section>
  );
};

export default SellCTASection;
